import dayjs from "dayjs";

const validityCheck = (orderData, order_id) => {
  const orderDateTime = dayjs(orderData?.orderTime || orderData?.timestamp, "YYYY-MM-DD HH:mm:ss");
  const systemDateTime = dayjs();

  const diffHoursDifferentDate = parseInt(process.env.REACT_APP_DIFF_HOURS_DIFFERENT_DATE) || 2;
  const diffHoursSameDate = parseInt(process.env.REACT_APP_DIFF_HOURS_SAME_DATE) || 3;

  const isSameDate = orderDateTime.isSame(systemDateTime, "day");

  if (!isSameDate) {
    const hoursDiff = systemDateTime.diff(orderDateTime, "hours");
    if (hoursDiff > diffHoursDifferentDate) {
      console.debug(`Print for order ${order_id} is too old (different date, ${hoursDiff} hours difference)`);
      return false;
    }
  } else {
    const hoursDiff = systemDateTime.diff(orderDateTime, "hours");
    if (hoursDiff > diffHoursSameDate) {
      console.debug(`Print for order ${order_id} is too old (same date, ${hoursDiff} hours difference)`);
      return false;
    }
  }

  return true;
};

export default validityCheck;
